<template>
  <div class="Armour h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="armour"
      :options="options"
      :options2="options2"
      :func1="this.links"
      :func2="this.type"
      filter1="Links"
      filter2="Category"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Armour",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 4em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "linkCount",
          label: "Links",
          sortable: true,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "Helmets", value: "helmets", disabled: false },
        { text: "Body", value: "bodyarmours", disabled: false },
        { text: "Shield", value: "shields", disabled: false },
        { text: "Boots", value: "boots", disabled: false },
        { text: "Gloves", value: "gloves", disabled: false },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"name":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"socket_filters":{"filters":{"links":{"r":null,"g":null,"b":null,"w":null,"a":null,"d":null,"min":${item.linkCount},"max":${item.linkCount}}},"disabled":false}}},"sort":{"price":"asc"}}`;
      }
    },
    links(val, item) {
      if (item.linkCount == val) {
        return true;
      }
      return false;
    },
    type(val, item) {
      if (item.group == val) {
        return true;
      }
      return false;
    },
  },
};
</script>
